module.exports = __webpack_public_path__ + "assets/img/flag-task-proposal.103db314.svg";